export const cartDataStorageKey = "cartData";
